import { Swiper } from 'swiper';
import { FreeMode, Thumbs, Scrollbar, Navigation } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  const swiperElement = document.querySelector<HTMLElement>(
    '[data-spot-single-swiper]'
  );
  const thumbnailSwiperElement = document.querySelector<HTMLElement>(
    '[data-spot-single-thumbnail-swiper]'
  );

  if (swiperElement && thumbnailSwiperElement) {
    const thumbSwiper = new Swiper(thumbnailSwiperElement, {
      modules: [FreeMode, Scrollbar],
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,

      scrollbar: {
        el: '.thumb-scrollbar',
        draggable: true,
      },

      breakpoints: {
        768: {
          spaceBetween: 32,
        },
      },
    });

    const mainSwiper = new Swiper(swiperElement, {
      modules: [Thumbs, Navigation],
      slidesPerView: 1.8,
      spaceBetween: 16,
      centeredSlides: true,
      loop: false,
      speed: 3000,
      thumbs: {
        swiper: thumbSwiper,
      },

      navigation: {
        nextEl: '[data-spot-single-swiper-next]',
        prevEl: '[data-spot-single-swiper-prev]',
      },
    });
  }
});
